import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';
import { I18n } from '@fiverr-private/i18n-react';

import classes from './style.module.scss';

const QR_URL = 'https://fiverr.onelink.me/3732212665/xzx1rxmf';

export const QrCodeSection = ({ className }) => (
    <div className={classnames(className, 'flex-start', 'flex-col', 'flex-items-center')}>
        <span className={classnames(classes.innerText)}>
            <I18n k="send_message.sent_confirmation.encourage_app_download.qr_code"/>
        </span>
        <QRCodeSVG className={classes.qrPlaceholder}
            value={QR_URL}/>
    </div>
);

QrCodeSection.propTypes = {
    className: PropTypes.string
};
